// extracted by mini-css-extract-plugin
export default {"container":"Adote_container__ZNEN+","titulo":"Adote_titulo__o+csT"};